export default "__VITE_ASSET__O5Z2cQ9p__"